import { Icon } from "./Icon.js";

/**
 * I due selettori booleani dell'app desktop, e sono **due** di proposito.
 *
 * Il `Toggle` a pillola (44x24) e' quello di `SettingsClustersTab.qml`, della
 * matrice dei permessi e delle schede di SISTEMA: si legge da lontano perche'
 * acceso e' verde. La `CheckBox` quadrata (18x18) e' quella di
 * `SettingsBackupTab.qml`: sta dentro un modulo che si conferma con un
 * bottone, e li' una levetta prometterebbe un effetto immediato che non c'e'.
 *
 * Attenzione: la levetta **non promette da sola** che il valore vada sul
 * server appena la si tocca. Nella matrice dei permessi non ci va — come nel
 * `.qml`, la riga cambia in pagina e si scrive con SALVA — e li' a dirlo e' il
 * bottone che si accende accanto al titolo.
 *
 * Nessuno dei due e' un `<input type="checkbox">` del browser: quello si
 * disegna come vuole il sistema operativo, e su questa schermata sarebbe
 * l'unico elemento che non viene dall'app desktop.
 */
export function Toggle({
  on,
  onChange,
  disabled,
  label,
  title,
}: {
  on: boolean;
  onChange: (v: boolean) => void;
  disabled?: boolean;
  label?: string;
  title?: string;
}) {
  const sw = (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={label ?? title ?? ""}
      className={`toggle${on ? " toggle--on" : ""}`}
      disabled={disabled === true}
      {...(title ? { title } : {})}
      onClick={() => onChange(!on)}
    >
      <span className="toggle__thumb" />
    </button>
  );
  // Etichetta a sinistra e levetta a destra: e' l'ordine del `Toggle` del .qml.
  if (label === undefined) return sw;
  return (
    <span className="togglefield">
      <span className="togglefield__label">{label}</span>
      {sw}
    </span>
  );
}

/** La casella quadrata del modulo FTP: vuota col bordo spento, piena del
 *  colore primario col segno di spunta quando e' scelta. */
export function CheckBox({
  on,
  onChange,
  label,
}: {
  on: boolean;
  onChange: (v: boolean) => void;
  label: string;
}) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={on}
      className="checkfield"
      onClick={() => onChange(!on)}
    >
      <span className={`checkbox${on ? " checkbox--on" : ""}`}>
        {on && <Icon name="check-circle" size={12} />}
      </span>
      <span className="checkfield__label">{label}</span>
    </button>
  );
}
